/* MC — Sticky add-to-cart bar (code original) */
if (!customElements.get('mc-sticky-atc')) {
  customElements.define(
    'mc-sticky-atc',
    class MCStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('.mc-sticky-atc__button');
        this.priceEl = this.querySelector('.mc-sticky-atc__price');

        this.mainForm = document.querySelector(`#MainProduct-${this.sectionId} form[data-type="add-to-cart-form"]`);
        this.mainSubmit = this.mainForm ? this.mainForm.querySelector('[name="add"]') : null;
        this.mainPrice = document.getElementById(`price-${this.sectionId}`);

        if (!this.mainSubmit) {
          this.remove();
          return;
        }

        this.button.addEventListener('click', () => {
          this.mainSubmit.click();
        });

        /* Show the bar once the real buy button leaves the viewport */
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const below = entry.boundingClientRect.top < 0;
              this.setAttribute('data-visible', (!entry.isIntersecting && below).toString());
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.mainSubmit);

        /* Mirror price + availability when the variant changes */
        this.sync();
        this.mutationObserver = new MutationObserver(() => this.sync());
        if (this.mainPrice) {
          this.mutationObserver.observe(this.mainPrice, { subtree: true, childList: true, characterData: true, attributes: true });
        }
        this.mutationObserver.observe(this.mainSubmit, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
      }

      sync() {
        if (this.mainPrice && this.priceEl) {
          const sale = this.mainPrice.querySelector('.price__sale .price-item--sale');
          const regular = this.mainPrice.querySelector('.price__regular .price-item--regular');
          const visible = this.mainPrice.classList.contains('price--on-sale') ? sale : regular;
          const source = visible || sale || regular;
          if (source) this.priceEl.textContent = source.textContent.trim();
        }
        const disabled = this.mainSubmit.hasAttribute('disabled');
        this.button.toggleAttribute('disabled', disabled);
        const mainLabel = this.mainSubmit.querySelector('span');
        if (mainLabel && mainLabel.textContent.trim().length) {
          this.button.querySelector('span').textContent = mainLabel.textContent.trim();
        }
      }
    }
  );
}
